module.exports = __webpack_public_path__ + "img/tarj2-5.38c3262d.svg";